import { render, staticRenderFns } from "./MasterSubordinateProductModal.vue?vue&type=template&id=647ff252&scoped=true&"
import script from "./MasterSubordinateProductModal.vue?vue&type=script&lang=js&"
export * from "./MasterSubordinateProductModal.vue?vue&type=script&lang=js&"
import style0 from "./MasterSubordinateProductModal.vue?vue&type=style&index=0&id=647ff252&scoped=true&lang=scss&"
import style1 from "./MasterSubordinateProductModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ff252",
  null
  
)

/* custom blocks */
import block0 from "./MasterSubordinateProductModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VContainer,VDialog,VForm,VTextField})
